import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { NgxSonnerToaster } from 'ngx-sonner';
import type { ClassValue } from 'clsx';

import { mergeClasses } from '@shared/utils/merge-classes';
import { toastVariants, type ZardToastVariants } from './toast.variants';

@Component({
  selector: 'z-toast, z-toaster',
  styles: [
    `

// .my-toast {
//   background-color: red;
// }
    `
  ],
  standalone: true,
  exportAs: 'zToast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgxSonnerToaster],
  template: `
    <ngx-sonner-toaster
     [toastOptions]="{
		 class: 'my-toast',
	}"
      [offset]="offset()"
      [visibleToasts]="visibleToasts()"
      [dir]="dir()"
      [toastOptions]="toastOptions()"
    />
  `,

  //       [theme]="theme()"
  // [class]="classes()"
  // [position]="position()"
  // [richColors]="richColors()"
  // [expand]="expand()"
  // [duration]="duration()"
  // [visibleToasts]="visibleToasts()"
  // [closeButton]="closeButton()"
  // [toastOptions]="toastOptions()",
})
export class ZardToastComponent {
  readonly class = input<ClassValue>('');
  readonly variant = input<ZardToastVariants['variant']>('default');
  readonly theme = input<'light' | 'dark' | 'system'>('system');
  readonly position = input<'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right'>('top-right');
  readonly richColors = input<boolean>(false);
  readonly expand = input<boolean>(false);
  readonly duration = input<number>(4000);
  readonly visibleToasts = input<number>(1);
  readonly closeButton = input<boolean>(false);
  readonly offset = input<string>('54px');
  readonly toastOptions = input<Record<string, unknown>>({});
  readonly dir = input<'ltr' | 'rtl' | 'auto'>('auto');
  readonly toasterStyles = input<Record<string, unknown>>({});

  protected readonly classes = computed(() => mergeClasses('toaster group', toastVariants({ variant: this.variant() }), this.class()));
}
